module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form>\n    <dl class=\'stepped zero\'>\n        Are you sure you want to create a new baseline alarm?\n    </dl>\n</form>\n';

}
return __p
}